module.exports = __webpack_public_path__ + "img/thumbnail_SunBear_j_normal.4cedcb01.png";